import {Injectable} from '@angular/core';
import {MembershipRenewal} from '../_models/membership-renewal';
import {BaseService} from './base-service';

@Injectable({
    providedIn: 'root'
})
export class MembershipRenewalService extends BaseService<MembershipRenewal> {
    destination = 'membership-renewals';

    emailWelcome(id: number) {
        return this.http.get(`${this.baseUrl()}/${id}/welcome`);
    }

    fireRenewalsJob() {
        return this.http.post(`${this.baseUrl()}/fire-renewals-job`, {});
    }

    fireEmailsJob() {
        return this.http.post(`${this.baseUrl()}/fire-emails-job`, {});
    }
}
